// @flow
import styled from 'styled-components';

export const ModalContentWrap = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  background: #fff;
`;
